<template>

</template>

<script>
export default {
  name: "QARSeguroAnterior"
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARSeguroAnterior.vue